module.exports = __webpack_public_path__ + "static/media/30.82cf6efe.mp4";